import React, { useState } from "react";
// Import Link
import { Link } from "react-router-dom";
// import Data
import { GalleryData } from "./data";

const GalleryArea = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  const openModal = (img) => setSelectedImg(img);
  const closeModal = () => setSelectedImg(null);

  return (
    <>
      <section id="gallery_grid_area" className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
              <div className="section_heading">
                <h3>Gallery</h3>
                <h2>
                  {" "}
                  Explore our <span className="color_big_heading">
                    gallery
                  </span>{" "}
                  to know how we work
                </h2>
              </div>
            </div>
          </div>
          <div className="row popup-gallery">
            {GalleryData.map((data, index) => (
              <div className="col-lg-4 co-md-6 col-sm-12 col-12" key={index}>
                <div className="gallery_item">
                  <img
                    src={data.img}
                    alt="img"
                    onClick={() => openModal(data.img)}
                  />
                  <div className="gallery_overlay">
                    <Link to="#!" onClick={() => openModal(data.img)}>
                      <img src={data.icon} alt="icon" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {selectedImg && (
        <div className="image-modal" onClick={closeModal}>
          <img
            src={selectedImg}
            alt="Full view"
            className="image-modal-content"
          />
        </div>
      )}
    </>
  );
};

export default GalleryArea;
